export const INDUSTRY_INSIGHT_COMPANY_ID = '99999';
export const INDUSTRY_INSIGHTS = 'Industry Insights';
